import { render, staticRenderFns } from "./ViewPoliceMedical.vue?vue&type=template&id=7c4c09b5&scoped=true&"
import script from "./ViewPoliceMedical.vue?vue&type=script&lang=js&"
export * from "./ViewPoliceMedical.vue?vue&type=script&lang=js&"
import style0 from "./ViewPoliceMedical.vue?vue&type=style&index=0&id=7c4c09b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4c09b5",
  null
  
)

export default component.exports